/**
 * Converts timeframe minutes to proper display format
 * @param minutes - Timeframe in minutes
 * @returns Formatted timeframe string (e.g., "M1", "H1", "D1")
 */
export const formatTimeframe = (minutes: number): string => {
  if (minutes < 60) {
    return `M${minutes}`;
  } else if (minutes < 1440) {
    const hours = minutes / 60;
    if (hours === Math.floor(hours)) {
      return `H${hours}`;
    } else {
      return `M${minutes}`;
    }
  } else if (minutes < 10080) {
    const days = minutes / 1440;
    if (days === Math.floor(days)) {
      return `D${days}`;
    } else {
      return `M${minutes}`;
    }
  } else if (minutes < 43200) {
    const weeks = minutes / 10080;
    if (weeks === Math.floor(weeks)) {
      return `W${weeks}`;
    } else {
      return `M${minutes}`;
    }
  } else {
    const months = minutes / 43200;
    if (months === Math.floor(months)) {
      return `MN${months}`;
    } else {
      return `M${minutes}`;
    }
  }
};